import { Spin } from 'antd';
import { Suspense, lazy } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import Layout from '../../../../components/Layout';
import Menu from '../../../../components/Layout/Menu';

const BusinessUpdateContent = lazy(() => import('../../../../components/Pages/Businesses/[businessId]/Update'));

export default function BusinessUpdate(): JSX.Element | null {
  document.title = `${process.env.REACT_APP_TITLE}: Business update`;

  return (
    <Layout LeftMenu={Menu} transparent>
      <Suspense fallback={<Spin spinning indicator={<LoadingOutlined spin />} />}>
        <BusinessUpdateContent />
      </Suspense>
    </Layout>
  );
}
